import { createMatchMediaConnect } from 'react-matchmedia-connect';

import { mobileMaxWidth } from '../layouts/theme';

const connectMediaQuery = createMatchMediaConnect(
  {
    isMobile: `(max-width: ${mobileMaxWidth}px)`,
  },
  {
    matchMediaFn:
      typeof window !== 'undefined'
        ? window.matchMedia
        : () => ({ matches: true, addListener: () => {} }),
  },
);

export default connectMediaQuery(['isMobile']);
